import React from 'react'
import styled from 'styled-components'
import Button from '../../../components/buttons/buttons.component'
import BuyerData from './buyer-data.component'
import AcceptTerms from './accept-terms.component'
import ModalError from './modal-error/modal-error'
import { checkoutErrorMessage, isPriceChangedError } from './post-payment-outcome'
import PaymentData from './payment-data.component'
import OrderSummary from './order-summary.component'
import DiscountCoupon from './discount-coupon.component'
import TravelInsurance from './travel-insurance.component'
import RequestNumberComponent from './request-number.component'
import AffiliateCodeComponent from './affiliate-code.component'
import ReasonForTravelData from './reason-travel-data.component'
import PassengersData from './passengers-data.component'
import ticketSaleHelper from '../../../helpers/ticket-sale.helper'
import {
	buildPayment,
	buildCheckoutParams,
	adaptCheckoutResponseData,
	resolvePaymentRequirement,
	resolveSelectedInstallment
} from '../../../helpers/checkout.helper'
import { CartService } from '../../../services/cart.service'
import TicketSaleSelectors from '../../../ducks/ticket-sale/ticket-sale.selectors'
import CreditCardPurchaseSelectors from '../../../ducks/credit-card-purchase/credit-card-purchase.selectors'
import BusSeatSelectionSelectors from '../../../selectors/bus-seat-selection.selectors'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { breakpoints, HANDLE_TYPE_CONSTANTS } from '../../../constants'
import { toastActions } from '../../../actions'
import { Creators as SiteCreators } from '../../../ducks/site/site'
import { Creators as TicketSaleCreators } from '../../../ducks/ticket-sale/ticket-sale'
import TripDiscountHelper from '../../../helpers/trip-discount.helper'
import { buildCalculatedValues } from '@helpers'
import {
	PAYMENT_METHODS,
	RoleConstants,
	USER_EVENTS_CONSTANTS
} from '../../../constants'
import { PRIMARY_COLOR } from '../../../styles/colors.style'
import { content } from '../../../../config'
import { userEvents } from '../../../helpers/user-events.helper'
import * as CPFService from '../../../services/cpf.service'
import {
	AdminTicketService,
	PassengerService,
	TicketSaleService
} from '../../../services'

const style = {
	container: {
		marginBottom: '2rem',
		lineHeight: '2em',
		borderBottom: `1px solid ${PRIMARY_COLOR}`,
		display: 'flex',
		boxPack: 'justify',
		justifyContent: 'space-between',
		boxAlign: 'center',
		alignItems: 'center',
		paddingBottom: '1rem'
	},
	title: {
		color: PRIMARY_COLOR,
		fontSize: '3.2rem',
		marginTop: '1rem'
	}
}

const InitialState = {
	isOpen: false,
	onClose: false,
	buyerValues: {},
	muvicardCpf: '',
	paymentValues: {},
	passengersValues: [],
	acceptTermsValues: {},
	htmlDebitContent: '',
	muvicardOneClick: false,
	buyerDataIsValid: false,
	modalErrorIsOpen: false,
	modalErrorMessage: '',
	acceptTermsIsValid: false,
	paymentDataIsValid: false,
	passengersDataIsValid: false,
	shouldRenderModalDebt: false,
	purchaseButtonDisabled: false,
	cpf: null,
	cpfChecked: false,
	couponPaymentMethod: 0,
	travelReasonValues: null,
	otherTravelReasonValues: null
}

class PaymentStepComponent extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			...InitialState,
			discountParameters: {},
			muvicardDiscountParameters: {}
		}

		this.forms = {}
		this.onClose = onClose.bind(this)
		this.onSubmitBuyer = onSubmitBuyer.bind(this)
		this.onSubmitPayment = onSubmitPayment.bind(this)
		this.finalizePurchase = finalizePurchase.bind(this)
		this.handleCloseModal = handleCloseModal.bind(this)
		this.onSubmitPassengers = onSubmitPassengers.bind(this)
		this.validateAndProceed = validateAndProceed.bind(this)
		this.onSubmitAcceptTerms = onSubmitAcceptTerms.bind(this)
		this.onSubmitReasonTravel = onSubmitReasonTravel.bind(this)
		this.backStepHandler = this.backStepHandler.bind(this)
		this.validatePassengersDuplicatedData = validatePassengersDuplicatedData.bind(
			this
		)
		this.resetState = resetState.bind(this)
	}

	async componentDidMount() {
		this.props.hideLoading()

		const { success, data } = await TicketSaleService.getDiscountParameters()

		if (success) {
			this.setState({ discountParameters: data })
		}
	}

	async componentDidUpdate(prevProps) {
		if (this.props.muvicardCpf !== prevProps.muvicardCpf) {
			let params = { cpf: this.props.muvicardCpf }
			await TicketSaleService.getMuvicardDiscountParameters(params).then(
				({ success, data }) => {
					if (success) {
						this.setState({ muvicardDiscountParameters: data })
					}
				}
			)
		}
	}

	backStepHandler() {
		this.props.history.push('/')
	}

	render() {
		const {
			user,
			previousStep,
			isPaymentStep,
			routeClassType,
			discountPercentage,
			backToPreviousStep,
			serviceChargeSelected,
			selectedBusSeatsGoing,
			selectedBusSeatsReturn,
			conexao,
			rebookingTicketValue,
			rebookingTicketPoints,
			discountLabel,
			paymentMethod,
			discountValue,
			setDiscountLabel,
			setDiscountValue,
			discountCouponCode,
			setDiscountPercent,
			calculatedValues
		} = this.props

		if (!this.props.isEtapaPagamento) {
			return <div />
		}
		const {
			ticketsGoing,
			ticketsReturn,
			totalDiscount,
			totalOrderValue,
			totalPointsUsed
		} = calculatedValues

		const originGoing = ticketsGoing[0].originCity
		const destinationGoing =
			ticketsGoing[ticketsGoing.length - 1].destinationCity

		let originReturn = ''
		let destinationReturn = ''

		if (ticketsReturn.length) {
			originReturn = ticketsReturn[0].originCity
			destinationReturn =
				ticketsReturn[ticketsReturn.length - 1].destinationCity
		}

		const isPublicBody = user && user.hasPublicBody
		const isRequester = user && user.isRequester

		const IsElegibleForBenefit = user && user.isEligibleForBenefit

		let busCompany = serviceChargeSelected
			? serviceChargeSelected.busCompany
			: ''

		const isInterstate = !!routeClassType.isInterstate

		const notOnlyPoints = totalOrderValue > 0

		let familyPercentDiscount = 0
		let muvicardPercentDiscount = 0

		let hasPromotionalSeat =
			ticketsGoing.find(ticketGoing => ticketGoing.isPromotionalSeat) ||
			ticketsReturn.find(ticketReturn => ticketReturn.isPromotionalSeat)

		// Desconto cupom
		let hasCouponDiscount = discountPercentage > 0 && !hasPromotionalSeat

		// Parametrização do Desconto família e Muvicard
		const { discountParameters, muvicardDiscountParameters } = this.state

		// Desconto Família - condições
		let conditionToApplyFamilyDiscount = TripDiscountHelper.getFamilyDiscount(
			discountParameters
		)

		// Desconto Família
		let hasFamilyDiscount = false

		if (discountParameters.discountFamily) {
			hasFamilyDiscount =
				(selectedBusSeatsGoing.length >= conditionToApplyFamilyDiscount ||
					selectedBusSeatsReturn.length >=
					conditionToApplyFamilyDiscount) &&
				discountPercentage <
				discountParameters.discountFamily.percentDiscount &&
				discountParameters.discountFamily.isActive &&
				totalPoints === 0 &&
				user !== null &&
				!hasPromotionalSeat

			if (hasFamilyDiscount)
				familyPercentDiscount =
					discountParameters.discountFamily.percentDiscount
		}

		// Desconto do cartão Muvicard
		let hasMuvicardDiscount = false

		if (
			muvicardDiscountParameters.muvicardDiscount &&
			paymentMethod === PAYMENT_METHODS.MUVICARD &&
			!hasPromotionalSeat
		) {
			let muvicardDiscountObject =
				muvicardDiscountParameters.muvicardDiscount

			hasMuvicardDiscount =
				muvicardDiscountObject.isActive && muvicardDiscountObject.isValid

			muvicardPercentDiscount = hasMuvicardDiscount
				? muvicardDiscountObject.percentDiscount
				: 0
		}

		let newDiscountLabel = ''

		// Muvicard
		if (
			hasMuvicardDiscount &&
			muvicardPercentDiscount > discountPercentage &&
			muvicardPercentDiscount > familyPercentDiscount
		) {
			newDiscountLabel = 'Desconto Muvicard'

			setDiscountPercent(discountPercentage)
			setDiscountLabel(discountLabel)
			setDiscountValue(totalDiscount)
		}

		if (discountLabel == 'Desconto Muvicard' && !hasMuvicardDiscount) {
			setDiscountPercent(0)
			setDiscountLabel('')
			setDiscountValue(0)
		}

		if (discountLabel == 'Cupom de desconto' && discountCouponCode == '') {
			setDiscountPercent(0)
			setDiscountLabel('')
			setDiscountValue(0)
		}

		// Cupom
		if (
			hasCouponDiscount &&
			discountPercentage >= muvicardPercentDiscount &&
			discountPercentage >= familyPercentDiscount
		) {
			newDiscountLabel = 'Cupom de desconto'

			setDiscountPercent(muvicardPercentDiscount)
			setDiscountLabel(discountLabel)
			setDiscountValue(totalDiscount)
		}

		// Família
		if (
			hasFamilyDiscount &&
			familyPercentDiscount > discountPercentage &&
			familyPercentDiscount > muvicardPercentDiscount
		) {
			newDiscountLabel = 'Desconto família'

			setDiscountPercent(familyPercentDiscount)
			setDiscountLabel(discountLabel)
			setDiscountValue(totalDiscount)
		}

		if (newDiscountLabel === '' && discountValue > 0) {
			setDiscountPercent(0)
			setDiscountValue(0)
			setDiscountLabel(null)
		}

		// Cobrar/estornar: prefere o cálculo pronto do carrinho (Spec remarcacao-cart-context,
		// operationType/amountDue já vem do backend) - só cai pro cálculo local quando o carrinho
		// ainda não tem o contexto de remarcação (carrinho criado antes desta migração).
		const { hasValueToRefund, totalValue, showPaymentSection } = resolvePaymentRequirement({
			rebookingContext: calculatedValues.rebookingContext,
			isRebooking: this.props.rebookingData.isRebooking,
			rebookingTicketValue,
			totalOrderValue
		})

		const isPromotionCoupon = this.props.discountCoupon.isPromotion

		return (
			<React.Fragment>
				<div style={style.container}>
					<div style={style.title}>{`Passageiro${ticketsGoing.length > 1 ? 's' : ''
						}`}</div>
				</div>
				<PassengersData
					onSubmit={this.onSubmitPassengers}
					getFormsRefs={getForms => (this.getPassengersForms = getForms)}
					showPointsMessagePassenger={true}
				/>
				{user == null ? (
					<React.Fragment>
						<div style={style.container}>
							<div style={style.title}>{`Dados do comprador`}</div>
						</div>
						<BuyerData
							onSubmit={this.onSubmitBuyer}
							getFormRef={form => (this.forms.buyerDataForm = form)}
							cpfChecked={() => {
								const cpfValid = CPFService.validate(this.state.cpf)
								this.setState({ cpfChecked: cpfValid })

								this.forms.buyerDataForm.submitForm()
							}}
							onChangeCpf={cpf => {
								this.setState({
									cpf: cpf,
									buyerDataIsValid: false,
									cpfChecked: false
								})

								if (!isPromotionCoupon) {
									this.props.resetDiscountCoupon()
								}
							}}
						/>
					</React.Fragment>
				) : null}
				{showPaymentSection ? (
					<React.Fragment>
						<div style={style.container}>
							<div style={style.title}>{`Forma de pagamento`}</div>
						</div>
						<PaymentData
							handleCompleteCpf={cpf => {
								this.setState({ muvicardCpf: cpf })
							}}
							totalValue={totalValue}
							busCompany={busCompany}
							onSubmit={this.onSubmitPayment}
							// O carrinho da MuviHub (payments/methods) ja e a fonte unica de
							// parcelamento no checkout novo - sem fallback pro endpoint legado
							// (creditcard/muvicard buscar-opcoes-parcelamento).
							disableLegacyInstallments
							getFormRef={form => (this.forms.paymentDataForm = form)}
						/>
					</React.Fragment>
				) : null}

				{/* Fora do bloco de pagamento de propósito: na compra só com pontos o seguro
				    também é cobrado (em pontos) e o cliente precisa poder recusá-lo. */}
				<TravelInsurance />

				{isRequester && (
					<React.Fragment>
						<div style={style.container}>
							<div style={style.title}>{`Requisição`}</div>
						</div>

						<RequestNumberComponent />
					</React.Fragment>
				)}

				{(!isPublicBody && notOnlyPoints && !IsElegibleForBenefit) ||
					isRequester ? (
					<React.Fragment>
						<div style={style.container}>
							<div
								style={style.title}>{`Possui cupom de desconto?`}</div>
						</div>

						<DiscountCoupon
							user={user}
							cpf={this.state.cpf || (user && user.cpf)}
							isCpfChecked={this.state.cpfChecked}
							busCompany={busCompany}
							boardingDate={this.props.tripDateGoing}
							isPaymentStep={isPaymentStep}
							busSeatsLength={selectedBusSeatsGoing.length}
							hasReturn={this.props.groupReturn ? true : false}
							originGoing={originGoing}
							originReturn={originReturn}
							destinationGoing={destinationGoing}
							destinationReturn={destinationReturn}
							busClass={this.props.tripGoing ? this.props.tripGoing.busClass : ''}
						/>
					</React.Fragment>
				) : null}

				<React.Fragment>
					<div style={style.container}>
						<div style={style.title}>{`Afiliado`}</div>
					</div>

					<AffiliateCodeComponent />
				</React.Fragment>
				<React.Fragment>
					<div style={style.container}>
						<div style={style.title}>{`Motivo de Viagem`}</div>
					</div>
					<ReasonForTravelData
						onSubmit={this.onSubmitReasonTravel}
						getFormRef={ref => (this.forms.reasonForTravelForm = ref)}
					/>
				</React.Fragment>

				<div style={style.container}>
					<div style={style.title}>{`Resumo do pedido`}</div>
				</div>

				<OrderSummary
					hasValueToRefund={hasValueToRefund}
					totalValue={totalValue}
				/>

				<AcceptTerms
					onSubmit={this.onSubmitAcceptTerms}
					getFormRef={ref => (this.forms.acceptTermsForm = ref)}
				/>
				<StyledButtonContainer>
					{/* Remover quando for conexão */}
					{!conexao.ehConexaoIda ? (
						<Button
							secondary
							type="button"
							onClick={() => this.backStepHandler()}>
							Voltar
						</Button>
					) : null}

					<Button
						primary
						type="button"
						className="finish-purchase"
						// Totais em recálculo (seguro, cupom): finalizar agora usaria o carrinho
						// anterior ao último clique - ex.: cobrar um seguro que o cliente acabou de
						// recusar.
						disabled={
							this.state.purchaseButtonDisabled || this.props.isCalculatingValues
						}
						onClick={() =>
							this.validateAndProceed(showPaymentSection, totalValue)
						}>
						Finalizar compra
					</Button>
				</StyledButtonContainer>
				<ModalError
					isOpen={this.state.modalErrorIsOpen}
					message={this.state.modalErrorMessage}
					onClose={this.handleCloseModal}
					isInterstateRedirect={
						isInterstate
							? () => (backToPreviousStep(), previousStep())
							: null
					}
				/>
			</React.Fragment>
		)
	}
}

function onClose() {
	this.setState({ isOpen: false })
	this.refs.form.resetForm()
}

function onSubmitBuyer(buyerValues) {
	this.setState({ buyerValues, buyerDataIsValid: true })
}

function onSubmitPayment(paymentValues) {
	this.setState({ paymentValues, paymentDataIsValid: true })
}

function onSubmitAcceptTerms(acceptTermsValues) {
	this.setState({ acceptTermsValues, acceptTermsIsValid: true })
}

function onSubmitReasonTravel(reasonTravelValues) {
	this.setState({
		travelReasonValues: reasonTravelValues.travelReason,
		otherTravelReasonValues: reasonTravelValues.otherTravelReason
	})
}

function handleCloseModal() {
	this.setState({ modalErrorIsOpen: false, modalErrorMessage: '' })
}

function onSubmitPassengers(passengerValues) {
	const { passengersValues } = this.state

	passengersValues.push(passengerValues)

	this.props.user !== null
		? PassengerService.addPassenger(passengerValues)
		: null

	this.setState({ passengersValues })

	if (passengersValues.length == this.props.numberOfPassengers) {
		this.setState({ passengersDataIsValid: true })
	}
}

function validatePassengersDuplicatedData() {
	const { passengersValues } = this.state

	for (const passenger of passengersValues) {
		const isDuplicatedData =
			passengersValues.filter(
				({ documenttype, documentnumber }) =>
					passenger.documenttype == documenttype &&
					passenger.documentnumber == documentnumber
			).length > 1
		if (isDuplicatedData) {
			return false
		}
	}

	return true
}

async function validateAndProceed(showPaymentSection, totalValue) {
	// Mesmo bloqueio do botão: com o PUT do seguro (ou o cupom) pendente, o carrinho no MuviHub e
	// o Redux ainda não refletem o último clique.
	if (this._isSubmitting || this.props.isCalculatingValues) return
	this._isSubmitting = true

	this.setState({
		...InitialState,
		passengersValues: [],
		purchaseButtonDisabled: true
	})

	const { user } = this.props

	if (!user) {
		await this.forms.buyerDataForm.submitForm()
	}

	if (showPaymentSection) {
		await this.forms.paymentDataForm.submitForm()
	} else {
		this.setState({ paymentDataIsValid: true })
	}

	const passengersForms = this.getPassengersForms()

	for (const passengerForm of passengersForms) {
		passengerForm.submitForm()
	}

	await this.forms.reasonForTravelForm.submitForm()

	// Validando o "Accept Terms"
	await this.forms.acceptTermsForm.submitForm()

	const noDuplicatedData = this.validatePassengersDuplicatedData()

	const {
		buyerDataIsValid,
		acceptTermsIsValid,
		paymentDataIsValid,
		passengersDataIsValid
	} = this.state

	const canProceed =
		noDuplicatedData &&
		acceptTermsIsValid && // Verifica se os termos foram aceitos
		paymentDataIsValid &&
		passengersDataIsValid &&
		(buyerDataIsValid || user)

	if (canProceed) {
		await this.finalizePurchase(totalValue)
	} else {
		this._isSubmitting = false
		this.setState({
			purchaseButtonDisabled: false
		})

		const message = getWarningMessage({
			buyerDataIsValid,
			paymentDataIsValid,
			passengersDataIsValid,
			isAuthenticated: !!user,
			noDuplicatedData,
			acceptTermsIsValid
		})

		if (message) this.props.toastWarning({ message })
	}
}

function getWarningMessage({
	buyerDataIsValid,
	paymentDataIsValid,
	passengersDataIsValid,
	isAuthenticated,
	noDuplicatedData,
	acceptTermsIsValid // Adiciona a verificação de AcceptTerms
}) {
	if (!acceptTermsIsValid)
		return 'Você precisa aceitar os termos para continuar'
	else if (!passengersDataIsValid) return 'Verifique os dados dos passageiros'
	else if (!noDuplicatedData)
		return 'O número do documento deve ser único para cada passageiro'
	else if (!(isAuthenticated || buyerDataIsValid))
		return 'Verifique os dados do comprador'
	else if (!paymentDataIsValid) return 'Verifique os dados de pagamento'
}

function resetState(errorMsg = '') {
	this._isSubmitting = false
	this.setState({
		...InitialState,
		modalErrorMessage: errorMsg,
		modalErrorIsOpen: !!errorMsg
	})
}

/**
 * Spec 062: relê o carrinho no Hub e refaz o calculatedValues (totais + contexto de remarcação), para a tela
 * mostrar o valor novo após um 409 Checkout.PriceChanged. Melhor esforço: se a leitura falhar, o cliente
 * continua com a mensagem do servidor e os valores se ajustam na próxima ação sobre o carrinho.
 */
async function reloadCartValues() {
	try {
		const cart = await CartService.getCart()
		const { ticketsGoing, ticketsReturn, rebookingContext } = this.props.calculatedValues

		this.props.setCalculatedValues(
			buildCalculatedValues(cart, ticketsGoing, ticketsReturn, rebookingContext)
		)
	} catch (e) {
		// ver acima
	}
}

async function finalizePurchase(totalValue) {
	const { hideLoading, showLoading, user, interestRate, tripGoing, tripReturn } =
		this.props

	let passagerBirthDay = null

	this.state.passengersValues.map(passenger => {
		if (passenger.loggedpassenger) {
			passagerBirthDay = passenger.birthdate
		}
	})

	const statesPrepared = this.state

	if (passagerBirthDay && !user.birthday) {
		statesPrepared.buyerValues = {
			...statesPrepared.buyerValues,
			birthdate: passagerBirthDay
		}
	}

	showLoading()

	try {
		const allowedAdmins = [
			RoleConstants.Employee,
			RoleConstants.Admin,
			RoleConstants.Sac,
			RoleConstants.SacUp
		]

		const userHasAdminRole =
			user && Array.isArray(user.roles)
				? user.roles.some(role => allowedAdmins.includes(role))
				: false

		const params = ticketSaleHelper.getParams(statesPrepared, this.props)

		const checkoutParams = buildCheckoutParams(statesPrepared, this.props)
		const selectedInstallment = resolveSelectedInstallment({
			payment: checkoutParams.payment,
			installmentsOptions: this.props.installmentsOptions,
			muvicardInstallmentsOptions: this.props.muvicardInstallmentsOptions
		})

		let response
		let usingNewCheckout = false

		const { isRebooking, rebookingOrderId, rebookingOrderNumber, rebookingTicketId } =
			this.props.rebookingData

		if (isRebooking) {
			// Remarcação: reusa o carrinho da viagem nova (já com o contexto de remarcação -
			// Spec remarcacao-cart-context) chamando o endpoint nativo que devolve/cancela o
			// bilhete antigo e cobra/estorna só a diferença - RebookingCheckoutHandler (MuviHub)
			// + RebookingTicketCommand (Moveflex). Nunca cai no checkout novo genérico
			// (CartService.checkout): esse não tem noção de bilhete remarcado.
			usingNewCheckout = true
			response = await CartService.rebook(CartService.getCurrentCartId(), {
				...checkoutParams,
				rebooking: {
					originalOrderId: rebookingOrderId,
					// Só necessário pra pedido legado-only (comprado antes da migração pro
					// carrinho nativo) - habilita o fallback ao legado no RebookingCheckoutHandler.
					...(rebookingOrderNumber ? { originalOrderNumber: rebookingOrderNumber } : {}),
					originalTicketId: rebookingTicketId
				}
			})
		} else if (checkoutParams.payment) {
			usingNewCheckout = true
			response = await CartService.checkout(checkoutParams)
		} else if (params.purchaseForCustomerId && userHasAdminRole) {
			response = await AdminTicketService.finalizePurchase(params)
		} else {
			response = await TicketSaleService.finalizePurchase(params)
		}

		const { success, errors, message } = response
		// No checkout novo (cartão de crédito, muvicard e pix), a emissão dos
		// bilhetes é assíncrona - a tela de confirmação faz polling em
		// me/orders/{id} até a emissão terminar (ou falhar), independente do
		// meio de pagamento escolhido, e mostra o bilhete automaticamente
		// quando estiver pronto.
		const isPendingEmission = usingNewCheckout
		const data = usingNewCheckout
			? {
					...adaptCheckoutResponseData(response.data, {
						goingLogoUrl: tripGoing && tripGoing.carrier && tripGoing.carrier.logoUrl,
						returnLogoUrl: tripReturn && tripReturn.carrier && tripReturn.carrier.logoUrl
					}),
					isPendingEmission
			  }
			: response.data

		this.props.setCalculatedValues({
			...this.props.calculatedValues,
			totalOrderValue: totalValue,
			// Juros da parcela escolhida NO MEIO usado (antes: sempre o do cartão, mesmo pagando com Muvicard).
			totalInterest: selectedInstallment ? Math.max(selectedInstallment.interest || 0, 0) : interestRate
		})

		hideLoading()

		if (!success)
			throw new Error((errors && errors[0]) || message || undefined)

		// Só limpa o contexto de remarcação numa compra bem-sucedida - se o
		// checkout falhar (ex: erro de pagamento), o usuário precisa poder tentar
		// de novo sem perder o desconto/estorno do bilhete original.
		this.props.resetRebookingData()

		const { setConfirmedPurchaseData, nextStep, goToNextStep } = this.props

		setConfirmedPurchaseData(data, this.state)
		nextStep()
		goToNextStep()

		window.dataLayer = window.dataLayer || []
		window.dataLayer.push({
			event: 'purchase',
			ecommerce: {
				transaction_id: data.orderNumber,
				value: data.orderValue,
				currency: 'BRL',
				items: [
					{
						item_name: 'Compra de passagem',
						item_id: '--',
						price: data.orderValue,
						quantity: 1,
						item_category: 'Compra de passagem',
						currency: 'BRL'
					}
				]
			}
		})

		window.fbq('track', 'Purchase', {
			value: data.orderValue,
			currency: 'BRL',
			content_type: 'product_group',
			content_ids: [data.orderNumber],
			contents: [
				{
					id: data.orderNumber,
					quantity: this.props.numberOfPassengers,
					item_price: data.orderValue / this.props.numberOfPassengers
				}
			]
		})

		const {
			tripGoing,
			tripReturn,
			campaignCode,
			rootURL,
			campaignSource
		} = this.props

		userEvents(
			data.orderNumber,
			HANDLE_TYPE_CONSTANTS.ORDER,
			USER_EVENTS_CONSTANTS.PURCHASE_COMPLETION,
			campaignCode,
			rootURL,
			campaignSource,
			{
				tripGoing,
				tripReturn
			}
		)

		// if params have object debitcard
		if (params.debitCard.length > 0) {
			debitCardModal(data)
		}
	} catch (errorMsg) {
		hideLoading()

		// Bug 8067: o texto padrao nao afirma que a compra nao foi cobrada - num
		// timeout o pedido pode existir e estar pago (bug 8005).
		let msg = `Parece que algo deu errado e não conseguimos confirmar a sua compra :(
			<br/><br/>Antes de tentar novamente, confira em Minhas Compras ou no seu e-mail se o pedido foi registrado.
			<br/><br/>Em caso de dúvida, envie e-mail para <a href="mailto:faleconosco@muviflex.com.br?Subject=Fale conosco - Muviflex site">faleconosco@muviflex.com.br</a>
		`
		const apiMessage = checkoutErrorMessage(errorMsg)

		// Spec 062: o total mudou desde que a tela foi carregada (nada foi cobrado) - além de mostrar a
		// mensagem do servidor, recarrega os valores do carrinho (e, com eles, as parcelas).
		if (isPriceChangedError(errorMsg)) await reloadCartValues.call(this)

		this._isSubmitting = false

		this.setState({
			purchaseButtonDisabled: false,
			modalErrorIsOpen: true,
			modalErrorMessage: apiMessage || msg
		})
	}
}

const debitCardModal = data => {
	if (data) {
		const { redirect_url, MD, PaReq, TermUrl } = data

		const obj = {
			MD,
			PaReq,
			TermUrl,
			redirectUrl: redirect_url
		}

		TicketSaleService.sendGetNetDebitCard(obj)
			.then(response => {
				if (response.success) {
					this.setState({
						htmlDebitContent: response.data,
						shouldRenderModalDebt: true,
						isOpen: true
					})
					hideLoading()
				}
			})
			.catch(console.error)
	}
}

const StyledButtonContainer = styled.div`
	display: flex;
	flex-direction: column-reverse;
	justify-content: flex-end;
	margin-top: 40px;
	margin-bottom: 60px;

	.finish-purchase {
		margin-bottom: 15px;
	}

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		flex-direction: row;

		.finish-purchase {
			margin-bottom: initial;
			margin-left: 15px;
		}
	}
`

const mapStateToProps = store => ({
	user: store.user,
	isCalculatingValues: store.ticketSale.isCalculatingValues,
	requestNumber: store.ticketSale.requestNumber,
	affiliateCode: store.ticketSale.affiliateCode,
	travelReason: store.ticketSale.travelReason,
	otherTravelReason: store.ticketSale.otherTravelReason,
	deviceId: store.antiFraud.sessionID,
	groupGoing: store.ticketSale.groupGoing,
	raceDateGoing: store.ticketSale.raceDateGoing,
	raceDateReturn: store.ticketSale.raceDateReturn,
	priceGoing: store.ticketSale.priceGoing,
	priceReturn: store.ticketSale.priceReturn,
	groupReturn: store.ticketSale.groupReturn,
	originState: store.ticketSale.originState,
	serviceGoing: store.ticketSale.serviceGoing,
	originPortal: store.ticketSale.originPortal,
	serviceReturn: store.ticketSale.serviceReturn,
	tripDateGoing: store.ticketSale.tripDateGoing,
	paymentMethod: store.ticketSale.paymentMethod,
	discountCoupon: store.ticketSale.discountCoupon,
	extraDataGoing: store.ticketSale.extraDataGoing,
	isUpgradeGoing: store.ticketSale.isUpgradeGoing,
	originIbgeCode: store.ticketSale.originIbgeCode,
	tripDateReturn: store.ticketSale.tripDateReturn,
	extraDataReturn: store.ticketSale.extraDataReturn,
	isUpgradeReturn: store.ticketSale.isUpgradeReturn,
	destinationState: store.ticketSale.destinationState,
	busSeatsGoing: store.busSeatSelection.busSeatsGoing,
	tripPriceGoing: store.ticketSale.selectedPriceGoing,
	originLocalityId: store.ticketSale.originLocalityId,
	tripPriceReturn: store.ticketSale.selectedPriceReturn,
	totalSeatsGoing: store.busSeatSelection.totalSeatsGoing,
	destinationIbgeCode: store.ticketSale.destinationIbgeCode,
	destinationLocalityId: store.ticketSale.destinationLocalityId,
	discountPercentage: store.ticketSale.discountCoupon.discountPercentage,
	rebookingTicketValue: store.ticketSale.rebookingData.rebookingValue,
	rebookingTicketPoints: store.ticketSale.rebookingData.rebookingPoints,
	tripGoing: TicketSaleSelectors.getTripGoing(store),
	tripReturn: TicketSaleSelectors.getTripReturn(store),
	isPaymentStep: TicketSaleSelectors.isPaymentStep(store),
	buyerAddress: TicketSaleSelectors.getBuyerAddress(store),
	routeClassType: TicketSaleSelectors.getRouteClassType(store),
	serviceCharge: TicketSaleSelectors.getServiceChargeValue(store),
	serviceChargeSelected: TicketSaleSelectors.getServiceChargeSelector(store),
	selectedServiceCharge: store.ticketSale.selectedServiceCharge,
	isEtapaPagamento: TicketSaleSelectors.getEtapaPagamento(store),
	numberOfPassengers: BusSeatSelectionSelectors.getNumberOfPassengers(
		store.busSeatSelection
	),
	selectedBusSeatsGoing: BusSeatSelectionSelectors.getSelectedBusSeatsGoing(
		store.busSeatSelection
	),
	selectedBusSeatsReturn: BusSeatSelectionSelectors.getSelectedBusSeatsReturn(
		store.busSeatSelection
	),
	selectedPoltonasIda: BusSeatSelectionSelectors.getSelectedViagemIda(
		store.busSeatSelection
	),
	selectedPoltonasVolta: BusSeatSelectionSelectors.getSelectedViagemVolta(
		store.busSeatSelection
	),
	conexao: store.conexao,
	rebookingData: store.ticketSale.rebookingData,
	discountLabel: store.ticketSale.discountLabel,
	discountValue: store.ticketSale.discountValue,
	discountCouponCode: store.ticketSale.discountCoupon.code,
	discountPercentage: store.ticketSale.discountCoupon.discountPercentage,
	calculatedValues: TicketSaleSelectors.getCalculatedValues(store),
	interestRate: CreditCardPurchaseSelectors.getInterestRate(
		store.creditCardPurchase
	),
	// D1/D10: grades de parcelas por meio — a parcela escolhida define o total enviado em displayedTotal.
	installmentsOptions: CreditCardPurchaseSelectors.getInstallmentsOptions(
		store.creditCardPurchase
	),
	muvicardInstallmentsOptions: store.muvicardPurchase.muvicardInstallmentsOptions,
	campaignCode: TicketSaleSelectors.getCampaignCode(store),
	rootURL: TicketSaleSelectors.getRootURL(store),
	campaignSource: TicketSaleSelectors.getCampaignSource(store)
})

const mapDispatchToProps = {
	toastWarning: toastActions.warning,
	hideLoading: SiteCreators.hideLoading,
	showLoading: SiteCreators.showLoading,
	goToNextStep: TicketSaleCreators.goToNextStep,
	backToPreviousStep: TicketSaleCreators.backToPreviousStep,
	setConfirmedPurchaseData: TicketSaleCreators.setConfirmedPurchaseData,
	resetDiscountCoupon: TicketSaleCreators.resetDiscountCoupon,
	resetRebookingData: TicketSaleCreators.resetRebookingData,
	setDiscountValue: TicketSaleCreators.discountValue,
	setDiscountLabel: TicketSaleCreators.discountLabel,
	setDiscountPercent: TicketSaleCreators.discountPercent,
	setTotalPointsOnTicketSale: TicketSaleCreators.totalPointsOnTicketSale,
	setCalculatedValues: TicketSaleCreators.setCalculatedValues
}

const PaymentStep = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(PaymentStepComponent)
)

export default PaymentStep
